import React, { useState } from 'react';
import './FaqSection.scss';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqs = [
  {
    question: "What is AlgoFabric?",
    answer: "AlgoFabric is a comprehensive, AI-powered portfolio and wealth management platform built exclusively for the Indian stock market. From real-time stock analysis and AI-driven insights to backtesting trading strategies and executing trades across Indian brokers — AlgoFabric brings the entire investment lifecycle into one seamless platform."
  },
  {
    question: "Which Indian markets and exchanges does AlgoFabric support?",
    answer: "AlgoFabric is designed specifically for Indian markets and supports stocks, indices, and instruments listed on the NSE (National Stock Exchange) and BSE (Bombay Stock Exchange). It covers 200+ Indian tickers with real-time data, technical, text based alerts like sentiments etc, and also AI-driven signals tailored to the Indian market landscape."
  },
  {
    question: "Can I connect my Indian brokerage account to AlgoFabric?",
    answer: "Yes. AlgoFabric offers seamless multi-broker integration with leading Indian brokers, allowing you to manage all your brokerage accounts from a single unified dashboard. You can execute bulk trades, track your portfolio in real time, and even consolidate family or client accounts — all without switching between platforms."
  },
  {
    question: "How does AlgoFabric help me build and test trading strategies for Indian stocks?",
    answer: "AlgoFabric features a powerful backtesting engine that lets you design, test, and deploy custom trading strategies using historical Indian market data. For example, you can backtest a strategy such as buying TCS when its closing price crosses above the 50-day moving average and selling when it falls below — directly through a conversational AI interface. Once validated, strategies can be deployed and executed automatically."
  }
];

const FaqSection = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-section-wrapper">
      <div className="faq-header">
        <span className="faq-subtitle">FAQS</span>
        <h2 className="faq-title">Questions Answered</h2>
      </div>
      
      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div 
            key={index} 
            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
          >
            <div 
              className="faq-question-container" 
              onClick={() => toggleAccordion(index)}
            >
              <h3 className="faq-question">{faq.question}</h3>
              <div className="faq-icon-wrapper">
                {activeIndex === index ? (
                  <ChevronUp size={20} className="faq-icon active-icon" />
                ) : (
                  <ChevronDown size={20} className="faq-icon" />
                )}
              </div>
            </div>
            
            <div 
              className="faq-answer-container"
              style={{
                maxHeight: activeIndex === index ? '500px' : '0',
                opacity: activeIndex === index ? 1 : 0,
                marginTop: activeIndex === index ? '15px' : '0'
              }}
            >
              <p className="faq-answer">{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
      
      {/* <div className="faq-footer">
        <span className="faq-footer-text">Still have questions? </span>
        <a href="#" className="faq-contact-link">Contact our team</a>
      </div> */}
    </div>
  );
};

export default FaqSection;
